// konashi5との通信を行う

const Consts = {
    HIGH: 1,
    LOW: 0,
    TOGGLE: 2,
    OUTPUT: 1,
    INPUT: 0,
    NOTIFY: 2,
    PULLUP: 1,
    PULLDOWN: 2,
    NO_PULLS: 0,
    ENABLE: 1,
    DISABLE: 0,
    TRUE: 1,
    FALSE: 0,
    DUTY: 1,
    PERIOD: 2
};
Object.freeze(Consts);

class Konashi {
    static _createUUID (part){
        return `064d${part}-8251-49d9-b6f3-f7ba35e5d0a1`;
    }

    static _sigCreateUUID (part){
        return `0000${part}-0000-1000-8000-00805f9b34fb`;
    }

    static get _serviceUUID (){
        return Konashi._createUUID('0100');
    }

    static get _configUUID (){
        return Konashi._createUUID('0200');
    }

    static get _controlUUID (){
        return Konashi._createUUID('0300');
    }

    static get _builtInUUID (){
        return Konashi._createUUID('0400');
    }

    /**
   * Return konashi's UUID(characteristic) with label
   *
   * @returns {object<string, string>} key: label, value: UUID
   */
    static get _c12cUUIDs (){
        return {
            config: Konashi._createUUID('0201'),
            rGpioConf: Konashi._createUUID('0202'),
            rSPWMConf: Konashi._createUUID('0203'),
            rHPWMConf: Konashi._createUUID('0204'),
            rAnalogConf: Konashi._createUUID('0205'),
            rI2CConf: Konashi._createUUID('0206'),
            rUartConf: Konashi._createUUID('0207'),
            rSPIConf: Konashi._createUUID('0208'),
            control: Konashi._createUUID('0301'),
            rGpioOut: Konashi._createUUID('0302'),
            rGpioIn: Konashi._createUUID('0303'),
            rSoftPWM: Konashi._createUUID('0304'),
            rHardPWM: Konashi._createUUID('0305'),
            rAnalogOut: Konashi._createUUID('0306'),
            rAnalogIn: Konashi._createUUID('0307'),
            rI2C: Konashi._createUUID('0308'),
            rUartData: Konashi._createUUID('0309'),
            rUartDone: Konashi._createUUID('030a'),
            rSPI: Konashi._createUUID('030b'),
            pres: Konashi._sigCreateUUID('2a6d'),
            temp: Konashi._sigCreateUUID('2a6e'),
            humi: Konashi._sigCreateUUID('2a6f'),
            bool: Konashi._sigCreateUUID('2ae2'),
            gylo: Konashi._createUUID('0402'),
            rgbSetting: Konashi._createUUID('0403'),
            rgbGet: Konashi._createUUID('0404')
        };
    }

    /**
     * request device & get UUID(in konashi.connect)
     *
     * @param {boolean} autoConnect connect automatically after the device is found (default: true)
     * @param {function} failedCallback called when the connection fails
     * @returns {Promise<void>} Promise resolved when the device has been found (and connected)
     */
    static find (autoConnect, failedCallback){
        if (typeof autoConnect === 'undefined') {
            autoConnect = true;
        }
        const options = {
            filters: [{services: [Konashi._serviceUUID]}],
            optionalServices: [Konashi._configUUID, Konashi._controlUUID, Konashi._builtInUUID]
        };
        return new Promise((resolve, reject) => {
            let konashi = null;
            navigator.bluetooth
                .requestDevice(options)
                .then(
                    d => {
                        konashi = new Konashi(d);
                        if (autoConnect) {
                            konashi.connect(failedCallback).then(resolve, reject);
                        } else {
                            resolve(konashi);
                        }
                    },
                    e => {
                        const askedRetrieve = /retrieve services/;
                        if (askedRetrieve.test(e)) {
                            konashi.connect().then(resolve, reject);
                        } else {
                            reject(e);
                        }
                    }
                );
                
        });
    }

    /**
     * constructor
     * TODO: Set Handlers?
     *
     * @param {BluetoothDevice} device target BLE device
     */
    constructor (device) {
        /** BluetoothDevice */
        this._device = device;
        /** BluetoothGATTRemoteServer */
        this._gatt = null;
        /** BluetoothGATTService */
        this._service = [];
        /** Object<String, BluetoothGATTCharacteristic> */
        this._c12c = {};
        /** Notify Event */
        this._events = {};
    
        for (const key in Consts) {
            this[key] = Consts[key];
        }
    }
    

    /**
   * Connect to konashi
   *
   * Assign `_gatt` and `_service` properties when the connection has been made.
   *
   * @param {function} failedCallback called when the connection fails
   * @returns {Promise<Konashi>} Promise resolved with this instance when connected
   */
    connect (failedCallback) {
        const that = this;
        return new Promise((resolve, reject) => {
            that._isConnectFailed = true;

            setTimeout(() => {
                if (that._isConnectFailed) {
                    console.log('time out');
                    failedCallback();
                    that._device.gatt.disconnect();
                }
            }, 6000);

            that._device.gatt.connect()// BLEデバイスへの接続（Serverオブジェクト）
                .then(
                    gatt => {
                        console.log('connecting');
                        that._isConnectFailed = false;

                        that._gatt = gatt;
                        return gatt.getPrimaryService(Konashi._serviceUUID);// Serviceオブジェクトの取得
                    },
                    e => reject(e)
                )
                .then(
                    service => {
                        that._service[0] = service;
                        return that._gatt.getPrimaryService(Konashi._configUUID);
                    }
                )
                .then(
                    service => {
                        that._service[1] = service;
                        return that._gatt.getPrimaryService(Konashi._controlUUID);
                    }
                )
                .then(
                    service => {
                        that._service[2] = service;
                        return that._gatt.getPrimaryService(Konashi._builtInUUID);
                    }
                )
                .then(
                    service => {
                        that._service[3] = service;
                        console.log('got services');
                        const promises = []; const keys = [];
                        for (const key in Konashi._c12cUUIDs) {
                            keys.push(key);
                        }
                        keys.forEach((label, i) => {
                            if (String(Konashi._c12cUUIDs[keys[i]]).includes('010')){
                                promises.push(
                                    that._service[0].getCharacteristic(Konashi._c12cUUIDs[label]).then(
                                        c => {
                                            // TODO: Watch changes of all characteristics
                                            // https://github.com/WebBluetoothCG/web-bluetooth/issues/176
                                            that._c12c[label] = c;
                                        }
                                    )
                                );
                            }
                            if (String(Konashi._c12cUUIDs[keys[i]]).includes('020')){
                                promises.push(
                                    that._service[1].getCharacteristic(Konashi._c12cUUIDs[label]).then(
                                        c => {
                                            // TODO: Watch changes of all characteristics
                                            // https://github.com/WebBluetoothCG/web-bluetooth/issues/176
                                            that._c12c[label] = c;
                                        }
                                    )
                                );
                            }
                            if (String(Konashi._c12cUUIDs[keys[i]]).includes('030')){
                                promises.push(
                                    that._service[2].getCharacteristic(Konashi._c12cUUIDs[label]).then(
                                        c => {
                                            // TODO: Watch changes of all characteristics
                                            // https://github.com/WebBluetoothCG/web-bluetooth/issues/176
                                            that._c12c[label] = c;
                                        }
                                    )
                                );
                            }
                            if (String(Konashi._c12cUUIDs[keys[i]]).includes('040') ||
                                String(Konashi._c12cUUIDs[keys[i]]).includes('2a')){
                                promises.push(
                                    that._service[3].getCharacteristic(Konashi._c12cUUIDs[label]).then(
                                        c => {
                                            // TODO: Watch changes of all characteristics
                                            // https://github.com/WebBluetoothCG/web-bluetooth/issues/176
                                            that._c12c[label] = c;
                                            // Promise.resolve();  なぞ。後でバグって必要になるかも？
                                        }
                                    )
                                );
                            }
                        });
                        console.log(this._c12c);
                        return Promise.all(promises);
                    },
                    e => reject(e)
                )
                .then(
                    () => resolve(that),
                    e => reject(e)
                )
                .catch(e => console.log(e));
        });
    }

    /**
   * Return connection condition
   *
   * @returns {boolean} true if connected
   */
    isConnected () {
        let connected = false;
        if (this._gatt) {
            connected = this._gatt.connected;
        }
        return connected;
    }

    isConnectionFailed () {
        return this._isConnectionFailed;
    }

    /**
   * Returns peripheral name
   *
   * @returns {string} peripheral name
   */
    name () {
        return this._device.name;
    }

    // { Digital I/O
    /**
   * Use this to get data before add event(notification)
   * @returns {Promise<DataView>} raw gpio config data
   * use with ".then(v=>{v.getUint8(variable)})"
   */
    readConf (){
        return this._c12c.rGpioConf.readValue();
    }

    /**
   * Set pin I/O & pull
   *
   * @param {number} pin Consts.PIO[0-7]
   * @param {number} able Consts.(ENABLE|DISABLE)
   * @param {number} io Consts.(INPUT|OUTPUT)
   * @param {number} flag Consts.(NOPULL|PULLDOWN|PULLUP)
   * @returns {Promise<void>} Promise resolved when the value has been written
   */
    setGpio (pin, able, io, flag){
        const data = ['0x01'];
        flag = (`00${flag.toString(2)}`).slice(-2);

        data.push(`0x${pin}${able}`);
        if (io < 2){
            data.push(`0b001${io}00${flag}`);
        } else if (io == 2){
            data.push(`0b001001${flag}`);
        } else if (io == 3){
            data.push(`0b001010${flag}`);
        } else return;

        return this._c12c.config.writeValueWithResponse(new Uint8Array(data));
    }

    /**
   * Write value to a digital pin
   *
   * @param {number} pin Consts.PIO[0-7]
   * @param {number} value Consts.(LOW|HIGH)
   * @returns {Promise<Void>} Promise resolved when the value has been written
   */
    digitalWrite (pin, value) {
        const data = ['0x01'];
        data.push(`0x${pin}${value}`);

        return this._c12c.control.writeValueWithResponse(new Uint8Array(data));
    }
    // Digital I/O }
    // {PWM
    /**
   * Set softPWM pin mode & (duty|period)
   *
   * @param {number} pin softPWM pin number
   * @param {number} ctrlt control type
   * @param {number} value value to write
   * @returns {Promise<void>} Promise resolved when the value has been written
   */
    setSoftPWM (pin, ctrlt, value){
        let data = ['0x02'];
        data.push(`0x${pin}${ctrlt}`);

        value = (`0000${value.toString(16)}`).slice(-4);
        value = [`0x${value.slice(2, 4)}`, `0x${value.slice(0, 2)}`];
        data = data.concat(value);
        return this._c12c.config.writeValueWithResponse(new Uint8Array(data));
    }

    /**
   * Write value & transition time to softPWM pin
   *
   * @param {number} pin softPWM pin number
   * @param {number} value value to write
   * @param {number} trans transition time
   * @returns {Promise<void>} Promise resolved when the value has been written
   */
    outSoftPWM (pin, value, trans){
        let data = ['0x02'];
        data.push(`0x0${pin}`);
    
        value = (`0000${value.toString(16)}`).slice(-4);
        value = [`0x${value.slice(2, 4)}`, `0x${value.slice(0, 2)}`];
        data = data.concat(value);
    
        trans = (`00000000${trans.toString(16)}`).slice(-8);
        trans = [`0x${trans.slice(6, 8)}`, `0x${trans.slice(4, 6)}`,
            `0x${trans.slice(2, 4)}`, `0x${trans.slice(0, 2)}`];
        data = data.concat(trans);
        return this._c12c.control.writeValueWithResponse(new Uint8Array(data));
    }
    setHardPwmPin (pin, able){
        const data = ['0x03'];
        data.push(`0x${pin}${able}`);
        return this._c12c.config.writeValueWithResponse(new Uint8Array(data));
    }
    setHardPWM (clk, presc, value){
        let data = ['0x03'];
        data.push('0xff');
        data.push(`0x${clk}${presc.toString(16)}`);

        value = (`0000${value.toString(16)}`).slice(-4);
        value = [`0x${value.slice(2, 4)}`, `0x${value.slice(0, 2)}`];
        data = data.concat(value);
        return this._c12c.config.writeValueWithResponse(new Uint8Array(data));
    }
    outHardPWM (pin, value, trans){
        let data = ['0x03'];
        data.push(`0x0${pin}`);
    
        value = (`0000${value.toString(16)}`).slice(-4);
        value = [`0x${value.slice(2, 4)}`, `0x${value.slice(0, 2)}`];
        data = data.concat(value);
    
        trans = (`00000000${trans.toString(16)}`).slice(-8);
        trans = [`0x${trans.slice(6, 8)}`, `0x${trans.slice(4, 6)}`,
            `0x${trans.slice(2, 4)}`, `0x${trans.slice(0, 2)}`];
        data = data.concat(trans);
        return this._c12c.control.writeValueWithResponse(new Uint8Array(data));
    }
    // PWM}
    // {Analog
    setAio (pin, able, io) {
        const data = ['0x04'];

        data.push(`0b00${(`00${pin.toString(2)}`).slice(-2)}${able}01${io}`);
        return this._c12c.config.writeValueWithResponse(new Uint8Array(data));
    }
    setAdcPeri (value) {
        const data = ['0x04', '0b11110000'];

        data.push(`0x${(`00${value.toString(16)}`).slice(-2)}`);
        return this._c12c.config.writeValueWithResponse(new Uint8Array(data));
    }
    setAnaConf (type, value) {
        const data = ['0x04'];

        data.push(`0b11${(`00${(3 - type).toString(2)}`).slice(-2)}${(`0000${value.toString(2)}`).slice(-4)}`);
        return this._c12c.config.writeValueWithResponse(new Uint8Array(data));
    }
    outAnalog (pin, ctrl, trans) {
        let data = ['0x04'];

        data.push(`0x0${pin}`);

        ctrl = (`0000${ctrl.toString(16)}`).slice(-4);
        ctrl = [`0x${ctrl.slice(2, 4)}`, `0x${ctrl.slice(0, 2)}`];
        data = data.concat(ctrl);
    
        trans = (`00000000${trans.toString(16)}`).slice(-8);
        trans = [`0x${trans.slice(6, 8)}`, `0x${trans.slice(4, 6)}`,
            `0x${trans.slice(2, 4)}`, `0x${trans.slice(0, 2)}`];
        data = data.concat(trans);
        return this._c12c.control.writeValueWithResponse(new Uint8Array(data));
    }
    // Analog}
    // {I2C
    setI2c (able, mode) {
        const data = ['0x05'];
        mode = mode + (able * 2);
        data.push(`0x0${mode}`);
        return this._c12c.config.writeValueWithResponse(new Uint8Array(data));
    }
    useI2c (op, rlen, addr, value) {
        const data = ['0x05'];
        data.push(`0x0${op}`);
        data.push(rlen);
        data.push(addr);
        // null/undefinedの双方を「データ部なし」として扱う（undefined流入時にクラッシュさせない）
        // eslint-disable-next-line eqeqeq, no-eq-null
        if (value != null){
            for (let i = 0; i < value.length; i++){
                data.push(value[i]);
            }
        }
        return this._c12c.control.writeValueWithResponse(new Uint8Array(data));
    }
    // I2C}
    // {UART
    setUart (able, parity, stopbit, baud) {
        let data = ['0x06'];
        data.push(`0b${able}000${(`00${parity.toString(2)}`).slice(-2)}${(`00${stopbit.toString(2)}`).slice(-2)}`);
  
        baud = (`00000000${baud.toString(16)}`).slice(-8);
        baud = [`0x${baud.slice(6, 8)}`, `0x${baud.slice(4, 6)}`, `0x${baud.slice(2, 4)}`, `0x${baud.slice(0, 2)}`];
        data = data.concat(baud);

        return this._c12c.config.writeValueWithResponse(new Uint8Array(data));
    }
    sendUart (value) {
        const data = ['0x06'];
        for (let i = 0; i < value.length; i++) {
            data.push(value[i]);
        }

        return this._c12c.control.writeValueWithResponse(new Uint8Array(data));
    }
    // UART}
    // {SPI
    setSpi (able, endian, pola, phas, speed) {
        let data = ['0x07'];
        data.push(`0b${able}000${endian}0${pola}${phas}`);

        speed = (`00000000${speed.toString(16)}`).slice(-8);
        speed = [`0x${speed.slice(6, 8)}`, `0x${speed.slice(4, 6)}`,
            `0x${speed.slice(2, 4)}`, `0x${speed.slice(0, 2)}`];
        data = data.concat(speed);

        return this._c12c.config.writeValueWithResponse(new Uint8Array(data));
    }
    writeSpi (value) {
        const data = ['0x07'];
        for (let i = 0; i < value.length; i++) {
            data.push(value[i]);
        }
        return this._c12c.control.writeValueWithResponse(new Uint8Array(data));
    }
    // SPI}
    // {Built In
    outColorLED (data, trans) {
        if (!Array.isArray(data)) return;

        trans = (`0000${trans.toString(16)}`).slice(-4);
        trans = [`0x${trans.slice(2, 4)}`, `0x${trans.slice(0, 2)}`];
        data = data.concat(trans);

        return this._c12c.rgbSetting.writeValueWithResponse(new Uint8Array(data));
    }
    // Built In}
    // {Notify
    startnotification (){
        const that = this;
    
        const promises = [];
        promises.push(that._c12c.rGpioIn.startNotifications());
        promises.push(that._c12c.rGpioOut.startNotifications());
        promises.push(that._c12c.rGpioConf.startNotifications());
        promises.push(that._c12c.rSPWMConf.startNotifications());
        promises.push(that._c12c.rSoftPWM.startNotifications());
        promises.push(that._c12c.rHPWMConf.startNotifications());
        promises.push(that._c12c.rHardPWM.startNotifications());
        promises.push(that._c12c.rAnalogConf.startNotifications());
        promises.push(that._c12c.rAnalogIn.startNotifications());
        promises.push(that._c12c.rAnalogOut.startNotifications());
        promises.push(that._c12c.rI2CConf.startNotifications());
        promises.push(that._c12c.rI2C.startNotifications());
        promises.push(that._c12c.rUartConf.startNotifications());
        promises.push(that._c12c.rUartData.startNotifications());
        promises.push(that._c12c.rUartDone.startNotifications());
        promises.push(that._c12c.rSPIConf.startNotifications());
        promises.push(that._c12c.rSPI.startNotifications());
        promises.push(that._c12c.pres.startNotifications());
        promises.push(that._c12c.temp.startNotifications());
        promises.push(that._c12c.humi.startNotifications());
        promises.push(that._c12c.bool.startNotifications());
        promises.push(that._c12c.gylo.startNotifications());
        promises.push(that._c12c.rgbGet.startNotifications());
        return Promise.all(promises);
    }

    /**
   *
   * @param {function} callback called when a notification is received
   * @returns {Promise} Promise resolved when all event listeners have been added
   */
    addEvents (callback){
        this._events.onReceivedConf = event => {
            const buf = event.target.value; let pre = ''; const v = [];
            for (let i = 0; i < 8; i++){
                pre = (`00${buf.getUint8((i * 2) + 1).toString(16)}`).slice(-2); // 桁合わせ(ゼロパディング)
                v[i] = [buf.getUint8(i * 2), parseInt(pre[0], 10), parseInt(pre[1], 10)];
            }
            callback(v, 0);
        };
        this._events.onReceivedGIO = event => {
            const buf = event.target.value; let pre = ''; const v = [];
            for (let i = 0; i < 8; i++){
                pre = (`00${buf.getUint8(i).toString(16)}`).slice(-2);
                v[i] = [parseInt(pre[0], 10), parseInt(pre[1], 10)];
            }
            callback(v, 1);
        };
        this._events.onReceivedCSPwm = event => {
            const buf = event.target.value; let pre = ''; const v = [];
            for (let i = 0; i < 4; i++){
                pre = buf.getUint8((i * 3) + 2).toString(16) +
                    (`00${buf.getUint8((i * 3) + 1).toString(16)}`).slice(-2);
                v[i] = [buf.getUint8(i * 3), parseInt(pre, 16)];
            }
            callback(v, 2);
        };
        this._events.onReceivedSPwm = event => {
            const buf = event.target.value; const pre = [null, null]; const v = [];
            for (let i = 0; i < 4; i++){
                pre[0] = buf.getUint8((i * 7) + 2).toString(16) +
                    (`00${buf.getUint8((i * 7) + 1).toString(16)}`).slice(-2);
                pre[1] = buf.getUint8((7 * i) + 6).toString(16) +
                    (`00${buf.getUint8((7 * i) + 5).toString(16)}`).slice(-2) +
                    (`00${buf.getUint8((7 * i) + 4).toString(16)}`).slice(-2) +
                    (`00${buf.getUint8((7 * i) + 3).toString(16)}`).slice(-2);
                v[i] = [buf.getUint8(i * 7), parseInt(pre[0], 16), parseInt(pre[1], 16)];
            }
            callback(v, 3);
        };
        this._events.onReceivedCHPwm = event => {
            const buf = event.target.value; const v = [];
            for (let i = 0; i < 4; i++){
                v[i] = buf.getUint8(i);
            }
            v.push(parseInt((`00${buf.getUint8(4).toString(16)}`).slice(-2), 16));
            v.push(parseInt(buf.getUint8(6).toString(16) + (`00${buf.getUint8(5).toString(16)}`).slice(-2), 16));
      
            callback(v, 4);
        };
        this._events.onReceivedHPwm = event => {
            const buf = event.target.value; const pre = [null, null]; const v = [];
            for (let i = 0; i < 4; i++){
                pre[0] = buf.getUint8((i * 6) + 1).toString(16) + (`00${buf.getUint8(i * 6).toString(16)}`).slice(-2);
                pre[1] = buf.getUint8((i * 6) + 5).toString(16) +
                    (`00${buf.getUint8((i * 6) + 4).toString(16)}`).slice(-2) +
                    (`00${buf.getUint8((i * 6) + 3).toString(16)}`).slice(-2) +
                    (`00${buf.getUint8((i * 6) + 2).toString(16)}`).slice(-2);
                v[i] = [parseInt(pre[0], 16), parseInt(pre[1], 16)];
            }
            callback(v, 5);
        };
        this._events.onReceivedAConf = event => {
            const buf = event.target.value; let pre = ''; const v = [];
            for (let i = 0; i < 7; i++){
                pre = (`0000${buf.getUint8(i).toString(2)}`).slice(-4);
                v[i] = [parseInt(pre[1], 2), parseInt(pre.slice(-2), 2)];
            }
            v[3] = buf.getUint8(3);
            callback(v, 6);
        };
        this._events.onReceivedAnalogOut = event => {
            const buf = event.target.value; const pre = [null, null]; const v = [];
            for (let i = 0; i < 3; i++){
                pre[0] = buf.getUint8((i * 7) + 2).toString(16) +
                    (`00${buf.getUint8((i * 7) + 1).toString(16)}`).slice(-2);
                pre[0] = buf.getUint8((i * 7) + 6).toString(16) +
                    (`00${buf.getUint8((i * 7) + 5).toString(16)}`).slice(-2) +
                    (`00${buf.getUint8((i * 7) + 4).toString(16)}`).slice(-2) +
                    (`00${buf.getUint8((i * 7) + 3).toString(16)}`).slice(-2);
                v[i] = [buf.getUint8((i * 7) + 1), parseInt(pre[0], 16), parseInt(pre[1], 16)];
            }
            v[3] = ((`00${buf.getUint8(0).toString(16)}`).slice(-2));
            if (v[3][0] == '0'){
                v[3] = parseInt(v[3][1], 10);
            } else v[3] = parseInt(v[3][0], 10);
            callback(v, 7);
        };
        this._events.onReceivedAnalogIn = event => {
            const buf = event.target.value; let pre = ''; const v = [];
            for (let i = 0; i < 3; i++){
                pre = buf.getUint8((i * 3) + 3).toString(16) +
                    (`00${buf.getUint8((i * 3) + 2).toString(16)}`).slice(-2);
                v[i] = [buf.getUint8((i * 3) + 1), parseInt(pre, 16)];
            }
            v[3] = buf.getUint8(0);
            callback(v, 7);
        };
        this._events.onReceivedI2Conf = event => {
            const buf = event.target.value.getUint8(0);
            callback(buf, 8);
        };
        this._events.onReceivedI2cIn = event => {
            const buf = event.target.value; let v = [];
            v = [buf.getUint8(0), buf.getUint8(1)];
            v[2] = [];
            for (let i = 2; i < 126; i++){
                try {
                    v[2].push(`0x${buf.getUint8(i).toString(16)}`);
                } catch (e){
                    break;
                }
            }
            v[2] = v[2].join(',');
            callback(v, 9);
        };
        this._events.onReceivedUartConf = event => {
            const buf = event.target.value; let pre = ''; const v = []; let m = 0;
            m = ((`00000000${buf.getUint8(0).toString(2)}`).slice(-8));
            v[0] = parseInt(m[0], 10);
            v[1] = (parseInt(m[4], 10) * 2) + parseInt(m[5], 10);
            v[2] = (parseInt(m[6], 10) * 2) + parseInt(m[7], 10);
            pre = buf.getUint8(4).toString(16) +
                (`00${buf.getUint8(3).toString(16)}`).slice(-2) +
                (`00${buf.getUint8(2).toString(16)}`).slice(-2) +
                (`00${buf.getUint8(1).toString(16)}`).slice(-2);
            v[3] = parseInt(pre, 16);
            callback(v, 10);
        };
        this._events.onReceivedUartIn = event => {
            const buf = event.target.value; let v = [];
            for (let i = 0; i < 128; i++){
                try {
                    v.push(`0x${buf.getUint8(i).toString(16)}`);
                } catch (e){
                    break;
                }
            }
            v = v.join(',');
            callback(v, 11);
        };
        this._events.onReceivedUartDone = event => {
            const buf = event.target.value; let v = null;
            v = buf.getUint8(0);
            callback(v, 12);
        };
        this._events.onReceivedSPIConf = event => {
            const buf = event.target.value; let pre = ''; const v = []; let m = 0;
            m = ((`00000000${buf.getUint8(0).toString(2)}`).slice(-8));
            v[0] = parseInt(m[0], 10);
            v[1] = parseInt(m[4], 10);
            v[2] = parseInt(m[6], 10);
            v[3] = parseInt(m[7], 10);
            pre = buf.getUint8(4).toString(16) +
                (`00${buf.getUint8(3).toString(16)}`).slice(-2) +
                (`00${buf.getUint8(2).toString(16)}`).slice(-2) +
                (`00${buf.getUint8(1).toString(16)}`).slice(-2);
            v[4] = parseInt(pre, 16);
            callback(v, 13);
        };
        this._events.onReceivedSpiIn = event => {
            const buf = event.target.value; let v = [];
            for (let i = 0; i < 127; i++){
                try {
                    v.push(`0x${buf.getUint8(i).toString(16)}`);
                } catch (e){
                    break;
                }
            }
            v = v.join(',');
            callback(v, 14);
        };
        this._events.onReceivedPres = event => {
            const buf = event.target.value; let v = '';
            v = buf.getUint8(3).toString(16) +
                (`00${buf.getUint8(2).toString(16)}`).slice(-2) +
                (`00${buf.getUint8(1).toString(16)}`).slice(-2) +
                (`00${buf.getUint8(0).toString(16)}`).slice(-2);
            v = parseInt(v, 16);
            callback(v, 15);
        };
        this._events.onReceivedTemp = event => {
            const buf = event.target.value; let v = '';
            v = buf.getUint8(1).toString(16) + (`00${buf.getUint8(0).toString(16)}`).slice(-2);
            v = parseInt(v, 16);
            callback(v, 16);
        };
        this._events.onReceivedHumi = event => {
            const buf = event.target.value; let v = '';
            v = buf.getUint8(1).toString(16) + (`00${buf.getUint8(0).toString(16)}`).slice(-2);
            v = parseInt(v, 16);
            callback(v, 17);
        };
        this._events.onReceivedBool = event => {
            const buf = event.target.value.getUint8(0);
            callback(buf, 18);
        };
        this._events.onReceivedGylo = event => {
            const buf = event.target.value; let pre = ''; const v = [];
            for (let i = 0; i < 6; i++){
                pre = buf.getUint8(i + 1).toString(16) + (`00${buf.getUint8(i).toString(16)}`).slice(-2);
                v[i] = parseInt(pre, 16);
            }
            callback(v, 19);
        };
        this._events.onReceivedRgb = event => {
            const buf = event.target.value; const color = [];
            for (let i = 0; i < 4; i++){
                color[i] = buf.getUint8(i);
            }
            color[4] = parseInt(buf.getUint8(5).toString(16) + (`00${buf.getUint8(4).toString(16)}`).slice(-2), 16);
            callback(color, 20);
        };
        const that = this;
    
        const promises = [];
        promises.push(that._c12c.rGpioIn.addEventListener('characteristicvaluechanged', that._events.onReceivedGIO));
        promises.push(that._c12c.rGpioOut.addEventListener('characteristicvaluechanged', that._events.onReceivedGIO));
        promises.push(that._c12c.rGpioConf.addEventListener('characteristicvaluechanged', that._events.onReceivedConf));
        promises.push(that._c12c.rSPWMConf
            .addEventListener('characteristicvaluechanged', that._events.onReceivedCSPwm));
        promises.push(that._c12c.rSoftPWM.addEventListener('characteristicvaluechanged', that._events.onReceivedSPwm));
        promises.push(that._c12c.rHPWMConf
            .addEventListener('characteristicvaluechanged', that._events.onReceivedCHPwm));
        promises.push(that._c12c.rHardPWM.addEventListener('characteristicvaluechanged', that._events.onReceivedHPwm));
        promises.push(that._c12c.rAnalogConf
            .addEventListener('characteristicvaluechanged', that._events.onReceivedAConf));
        promises.push(that._c12c.rAnalogIn
            .addEventListener('characteristicvaluechanged', that._events.onReceivedAnalogIn));
        promises.push(that._c12c.rAnalogOut
            .addEventListener('characteristicvaluechanged', that._events.onReceivedAnalogOut));
        promises.push(that._c12c.rI2CConf
            .addEventListener('characteristicvaluechanged', that._events.onReceivedI2Conf));
        promises.push(that._c12c.rI2C.addEventListener('characteristicvaluechanged', that._events.onReceivedI2cIn));
        promises.push(that._c12c.rUartConf
            .addEventListener('characteristicvaluechanged', that._events.onReceivedUartConf));
        promises.push(that._c12c.rUartData
            .addEventListener('characteristicvaluechanged', that._events.onReceivedUartIn));
        promises.push(that._c12c.rUartDone
            .addEventListener('characteristicvaluechanged', that._events.onReceivedUartDone));
        promises.push(that._c12c.rSPIConf
            .addEventListener('characteristicvaluechanged', that._events.onReceivedSPIConf));
        promises.push(that._c12c.rSPI.addEventListener('characteristicvaluechanged', that._events.onReceivedSpiIn));
        promises.push(that._c12c.pres.addEventListener('characteristicvaluechanged', that._events.onReceivedPres));
        promises.push(that._c12c.temp.addEventListener('characteristicvaluechanged', that._events.onReceivedTemp));
        promises.push(that._c12c.humi.addEventListener('characteristicvaluechanged', that._events.onReceivedHumi));
        promises.push(that._c12c.bool.addEventListener('characteristicvaluechanged', that._events.onReceivedBool));
        promises.push(that._c12c.gylo.addEventListener('characteristicvaluechanged', that._events.onReceivedGylo));
        promises.push(that._c12c.rgbGet.addEventListener('characteristicvaluechanged', that._events.onReceivedRgb));
        return Promise.all(promises);
    }
    removeEvents (){
        const that = this;

        const promises = [];
        promises.push(that._c12c.rGpioIn.removeEventListener('characteristicvaluechanged', that._events.onReceivedGIO));
        promises.push(that._c12c.rGpioOut
            .removeEventListener('characteristicvaluechanged', that._events.onReceivedGIO));
        promises.push(that._c12c.rGpioConf
            .removeEventListener('characteristicvaluechanged', that._events.onReceivedConf));
        promises.push(that._c12c.rSPWMConf
            .removeEventListener('characteristicvaluechanged', that._events.onReceivedCSPwm));
        promises.push(that._c12c.rSoftPWM
            .removeEventListener('characteristicvaluechanged', that._events.onReceivedSPwm));
        promises.push(that._c12c.rHPWMConf
            .removeEventListener('characteristicvaluechanged', that._events.onReceivedCHPwm));
        promises.push(that._c12c.rHardPWM
            .removeEventListener('characteristicvaluechanged', that._events.onReceivedHPwm));
        promises.push(that._c12c.rAnalogConf
            .removeEventListener('characteristicvaluechanged', that._events.onReceivedAConf));
        promises.push(that._c12c.rAnalogIn
            .removeEventListener('characteristicvaluechanged', that._events.onReceivedAnalogIn));
        promises.push(that._c12c.rAnalogOut
            .removeEventListener('characteristicvaluechanged', that._events.onReceivedAnalogOut));
        promises.push(that._c12c.rI2CConf
            .removeEventListener('characteristicvaluechanged', that._events.onReceivedI2Conf));
        promises.push(that._c12c.rI2C.removeEventListener('characteristicvaluechanged', that._events.onReceivedI2cIn));
        promises.push(that._c12c.rUartConf
            .removeEventListener('characteristicvaluechanged', that._events.onReceivedUartConf));
        promises.push(that._c12c.rUartData
            .removeEventListener('characteristicvaluechanged', that._events.onReceivedUartIn));
        promises.push(that._c12c.rUartDone
            .removeEventListener('characteristicvaluechanged', that._events.onReceivedUartDone));
        promises.push(that._c12c.rSPIConf
            .removeEventListener('characteristicvaluechanged', that._events.onReceivedSPIConf));
        promises.push(that._c12c.rSPI.removeEventListener('characteristicvaluechanged', that._events.onReceivedSpiIn));
        promises.push(that._c12c.pres.removeEventListener('characteristicvaluechanged', that._events.onReceivedPres));
        promises.push(that._c12c.temp.removeEventListener('characteristicvaluechanged', that._events.onReceivedTemp));
        promises.push(that._c12c.humi.removeEventListener('characteristicvaluechanged', that._events.onReceivedHumi));
        promises.push(that._c12c.bool.removeEventListener('characteristicvaluechanged', that._events.onReceivedBool));
        promises.push(that._c12c.gylo.removeEventListener('characteristicvaluechanged', that._events.onReceivedGylo));
        promises.push(that._c12c.rgbGet.removeEventListener('characteristicvaluechanged', that._events.onReceivedRgb));
        return Promise.all(promises);
    }
    // Notify}
    // { Hardware Control

    /**
   * Disconnect
   *
   * @returns {void} return value of gatt.disconnect()
   */
    disconnect () {
        return this._gatt.disconnect();
    }
}


exports.funcs = Konashi;
exports.consts = Consts;
